export const CUSTOMER_OPEN_ADD_MODAL = "CUSTOMER_OPEN_ADD_MODAL";
export const CUSTOMER_DETAIL_BAN = "CUSTOMER_DETAIL_BAN";
export const CUSTOMER_DETAIL_DELETE = "CUSTOMER_DETAIL_DELETE";
export const CUSTOMER_EDIT_SAVE = "CUSTOMER_EDIT_SAVE";
export const CUSTOMER_EDIT_CANCEL = "CUSTOMER_EDIT_CANCEL";
